import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import { Location } from "../../../@types/location";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";
export const findLocations = createAsyncThunk(
  "locations/find",
  async (searchText, { rejectWithValue, getState }) => {
    const state = getState() as RootState;

    try {
      const { data } = await axiosInstance.get(`${api.baseURL}location`, {
        params: {
          //where: { usersCount: { ">=": 1 } },
          populate: ["organization", "category"].join(","),
          limit: 10000,
          sort: "name ASC",
          where: { 
          sourceOrganization: state.userAuthentication.user?.sourceOrganization, 
        }
        },
      });
      return data as Location[];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
